import { IReservation, IReservationCode } from '@/types';

export function isCancelOrRebook(data: IReservation) {
  return data?.reservation_status == 'C' || data?.reservation_status == 'BS';
}

export function getReservationCodeCodeLabel(facility_url_code: string) {
  if (isArrive(facility_url_code)) {
    return 'Parking Pass Id';
  }
  return 'Reservation Code';
}
export function isResLab(facility_url_code: string) {
  return facility_url_code?.startsWith('rl_');
}
export function isCavu(facility_url_code: string) {
  return facility_url_code?.startsWith('cavu_');
}
export function isArrive(facility_url_code: string) {
  return facility_url_code?.startsWith('arv_');
}

export function isExternal(facility_url_code: string) {
  return isArrive(facility_url_code) || isCavu(facility_url_code) || isResLab(facility_url_code);
}
export function getReservationCodeFromLabel(facility_url_code: string) {
  if (isArrive(facility_url_code)) {
    return 'Start';
  }
  return 'From';
}

export function getReservationCodeToLabel(facility_url_code: string) {
  if (isArrive(facility_url_code)) {
    return 'End';
  }
  return 'To';
}

